import { render, staticRenderFns } from "./About.vue?vue&type=template&id=781099ee&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=781099ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781099ee",
  null
  
)

export default component.exports